export { ReactComponent as SecuredByStripe } from './secured-by-stripe.svg';
